var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.url
    ? _c(
        "a",
        { staticClass: "c-quick-links__item", attrs: { href: _vm.url } },
        [
          _c("v-icon", {
            attrs: {
              name: _vm.icon,
              size: "xl",
              "css-modifiers": "c-quick-links__icon"
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "c-quick-links__text" }, [
            _vm._v(_vm._s(_vm.heading))
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }